import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-jobseekers-shell',
  templateUrl: './jobseekers-shell.component.html',
  styleUrls: ['./jobseekers-shell.component.css'],
  standalone: false,
})
export class JobseekersShellComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
